<div class="modal-dialog modal-dialog-centered modal-md">
  <div class="modal-content">
    <div class="modal-header">
      <div class="row">
        <h5 class="modal-title container" i18n>Exportar</h5>
        <hr class="my-3">
        <p class="container" i18n>
          Selecione abaixo o arquivo que deseja exportar:
        </p>
      </div>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body">
      <p>
        <mat-checkbox i18n
          color="primary"
          (change)="selectOption('certificate')"
          [checked]="options.certificate.selected">
          Certificado de Aferição
        </mat-checkbox>
      </p>
      <p>
        <mat-checkbox i18n
          color="primary"
          (change)="selectOption('registry')"
          [checked]="options.registry.selected">
          Registro de Medição
        </mat-checkbox>
      </p>
      <p>
        <mat-checkbox i18n
          color="primary"
          (change)="selectOption('all')"
          [checked]="options.all.selected">
          Todos (Certificado + Registro)
        </mat-checkbox>
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="onCancel()">
        <app-loading
          [load]="loading"
          text="Cancelar"
          i18n-text>
        </app-loading>
      </button>
      <button class="btn btn-primary" (click)="onSubmit()">
        <app-loading
          [load]="loading"
          text="Confirmar"
          i18n-text>
        </app-loading>
      </button>
    </div>
  </div>
</div>
